import { render } from "./RulesInput.vue?vue&type=template&id=76df48f3&ts=true"
import script from "./RulesInput.vue?vue&type=script&lang=ts"
export * from "./RulesInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__